import { IPostingsWithWidgetAndTotalCountQuery } from '../interfaces/interfaces/postings-with-widget-and-total-count.query.interface';
import { PostingsWithWidget } from './postings-with-widget.model';

export class PostingsWithWidgetAndTotalCount {
    data: PostingsWithWidget[];
    numberOfResults: number;

    constructor(postingsWithWidgetQuery: IPostingsWithWidgetAndTotalCountQuery) {
        this.data = postingsWithWidgetQuery.data.map((postingsWithGroup) => new PostingsWithWidget(postingsWithGroup));
        this.numberOfResults = postingsWithWidgetQuery.number_of_results;
    }
}
